<template>
  <div class="print-select-seat-sticker">
    <el-button class="grid-menu-item"
               @click="handlePrint" :loading="loading">
      <i class="iconfont icon-printer"></i><span class="text-span">打印座位标贴</span>
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'PrintSelectSeatSticker',
  props: {
    extraParams: Object
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    handlePrint () {
      let menuAction = this.$parent.$parent.$parent.$parent
      // console.log(menuAction)
      // console.log(menuAction.getGridSearchParams())
      // console.log(menuAction.selection)
      if (!menuAction) {
        this.$message.warning('匹配参数失败')
        return false
      }
      let postId = menuAction.selection
      if (!postId || postId.length <= 0) {
        this.$confirm('不选择数据行将默认打印全部的座位标贴, 是否继续打印?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.confimPrint(menuAction, [])
        }).catch(() => {
        })
      } else {
        this.confimPrint(menuAction, postId)
      }
    },
    confimPrint (menuAction, postId) {
      let param = {
        gridId: menuAction['$attrs'].gridId,
        tabsId: menuAction['$attrs'].tabsId,
        selectAllSearch: menuAction.isSelectAll,
        postIds: postId,
        postSearch: JSON.stringify(menuAction.getGridSearchParams()),
        studentType: this.extraParams.studentType
      }
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/exam/student/print/select/seat/sticker',
        method: 'post',
        data: this.$qs.stringify(
          this.$extend(param),
          {arrayFormat: 'repeat'}
        )
      }).then(
        (response) => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                // window.open(response.data['pdfUrl'], '_blank')
                const link = document.createElement('a')
                link.href = response.data['pdfUrl']
                link.target = '_blank'
                // 将链接添加到页面中
                document.body.appendChild(link)
                // 模拟点击链接
                link.click()
                link.remove()
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        },
        () => {
          this.$message.error('请求发送失败，请稍候重试')
        }
      ).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.print-select-seat-sticker{
  .grid-menu-item{
    background-color: white;
    .text-span {
      vertical-align: 2px;
    }
    &:hover{
      background-color: white;
    }
  }
}
</style>
